import * as React from 'react';
import { ToggleButtonGroup } from '@mui/material';

import { Create, ReferenceInput, SelectInput, SimpleForm, TextInput } from 'react-admin';
import { RichTextInput } from '../../components/RichTextJsonInput';
import { RichTextInputToolbar, LevelSelect, ListButtons, LinkButtons, ClearButtons } from 'ra-input-rich-text';
import { CustomFormatButtons } from '../../components/FormatButtons';
import { HorizontalRuleButton } from '../../components/HorizontalRuleButton';
import { ImageButton } from '../../components/ImageButton';
import { LinkContentButton } from '../../components/LinkContentButton';
import { LinkFileButton } from '../../components/LinkFileButton';
import { VideoButton } from '../../components/VideoButton';
import NewsResource from '../News/NewsResource';

export const DepartmentCreate = (props: any) => (
  <Create {...props}>
    <SimpleForm>
      <TextInput source="name" />
      <ReferenceInput label="LTO" source="ltoId" reference="ltos">
        <SelectInput optionText="name" />
      </ReferenceInput>
      <RichTextInput
        source="content"
        contentType="json"
        toolbar={
          <RichTextInputToolbar>
            <LevelSelect />
            <HorizontalRuleButton />
            <CustomFormatButtons />
            <ListButtons />
            <ToggleButtonGroup>
              <LinkButtons />
              <LinkContentButton resource={NewsResource.name}  />
              <LinkFileButton allowed={['application/msword', 'application/msexcel', 'application/pdf', 'text/plain', 'application/vnd.ms-powerpoint']} />
            </ToggleButtonGroup>
            <ToggleButtonGroup>
              <ImageButton />
              <VideoButton />
            </ToggleButtonGroup>
            <ClearButtons />
          </RichTextInputToolbar>
        }
      />
    </SimpleForm>
  </Create>
);
